import { MERCHANT } from "constants/action-types";
import { Observable } from "rxjs";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import {
    GetMerchantPreferenceRequestAction,
    getMerchantPreferenceComplete,
    UpdateMerchantPreferenceRequestAction,
    updateMerchantPreferenceComplete,
} from "actions/merchant/merchant-preference";
import { formatMessage } from "lib/globalize-util";
import { add as snackbarAdd } from "actions/snackbars";
import { updateableMerchantPreferenceFields } from "constants/merchant";

export const getMerchantPreferenceEpic = (action$: ActionsObservable<GetMerchantPreferenceRequestAction>) =>
    action$
        .ofType(MERCHANT.PREFERENCE.GET.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId }) => {
            return ajax(`${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/preference`)
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }
                    return [getMerchantPreferenceComplete(response)];
                })
                .catch((error) => Observable.merge(Observable.of(getMerchantPreferenceComplete(error))));
        });

export const updateMerchantPreferenceEpic = (action$: ActionsObservable<UpdateMerchantPreferenceRequestAction>) =>
    action$
        .ofType(MERCHANT.PREFERENCE.UPDATE.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId, preference }) => {
            // Only save accepted keys
            const updatingData = Object.keys(preference).reduce((acc, key) => {
                if (updateableMerchantPreferenceFields[key]) {
                    acc[key] = preference[key];
                }
                return acc;
            }, {});
            return ajax({
                method: "PUT",
                url: `${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/preference`,
                body: {
                    preference: updatingData,
                    update_mask: {
                        paths: Object.keys(updatingData),
                    },
                },
            })
                .flatMap(({ response }) => {
                    return [
                        updateMerchantPreferenceComplete(response),
                        snackbarAdd({ message: formatMessage("Merchant preference updated") }),
                    ];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of(updateMerchantPreferenceComplete(error)),
                        Observable.of(snackbarAdd({ message: error.message || formatMessage("Error saving") }))
                    )
                );
        });
